import { SpreadingState } from "@components/main/spreading/state/manager";
import { Row } from "@components/main/spreading/models/models";

export type CategorizationViewKey =
  | 'document-item'
  | 'manual-item'
  | 'offset-adjustment';

export interface CategorizationViewConfig {
  value: CategorizationViewKey;
  label: string;
}

export const CATEGORIZATION_VIEW_CONFIGS: CategorizationViewConfig[] = [
  { value: 'document-item', label: 'Document Item' },
  { value: 'manual-item', label: 'Manual Item' },
  { value: 'offset-adjustment', label: 'Offset Adjustment' },
];

export const DEFAULT_CATEGORIZATION_VIEW: CategorizationViewKey = 'document-item';

/**
 * Template items that take validation categorizations cannot take an offset adjustment, which is
 * always a pair of component categorizations, so that view is hidden for them.
 */
export function getAvailableViewConfigs(
  isValidationTemplateItem: boolean
): CategorizationViewConfig[] {
  if (!isValidationTemplateItem) {
    return CATEGORIZATION_VIEW_CONFIGS;
  }
  return CATEGORIZATION_VIEW_CONFIGS.filter(
    (config) => config.value !== 'offset-adjustment'
  );
}

export interface DocumentItemCategorizePayload {
  rows: Row[];
  isValidation: boolean;
}

export function getViewLabel(key: CategorizationViewKey): string {
  const config = CATEGORIZATION_VIEW_CONFIGS.find((c) => c.value === key);
  return config?.label ?? '';
}
